import { render, staticRenderFns } from "./ZakatAffidavitPreviewPopup.vue?vue&type=template&id=060e8df0&"
import script from "./ZakatAffidavitPreviewPopup.vue?vue&type=script&lang=js&"
export * from "./ZakatAffidavitPreviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports